export default __webpack_public_path__ + "static/media/tower_logo.ca197a50.svg";